export default {
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    hasIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    canGoBack: {
      type: Boolean,
      required: false,
      default: true,
    },
    isExpanded: {
      type: Boolean,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['expand', 'update:modelValue', 'apply', 'back'],
  data() {
    return {
      options: [],
      currentFilter: {
        value: [],
        labels: [],
      },
      optionValueProperty: 'id',
      optionLabelProperty: 'display',
      optionsLoaded: false,
      optionFilter: null,
      stateSnapshot: null,
    };
  },
  methods: {
    init() {
      this.currentFilter.value = JSON.parse(JSON.stringify(this.currentValue.value ?? []));
      this.initLabels();
    },
    snapshotFilterState() {
      this.stateSnapshot = {
        options: JSON.parse(JSON.stringify(this.options ?? [])),
        currentFilter: JSON.parse(JSON.stringify(this.currentFilter ?? {value: [], labels: []})),
        currentValue: JSON.parse(JSON.stringify(this.currentValue ?? {value: null, labels: []})),
      };
    },
    restoreFilterState() {
      if (!this.stateSnapshot) return;
      this.options = JSON.parse(JSON.stringify(this.stateSnapshot.options));
      this.currentFilter = JSON.parse(JSON.stringify(this.stateSnapshot.currentFilter));
      this.currentValue = JSON.parse(JSON.stringify(this.stateSnapshot.currentValue));
    },
    commitFilterState() {
      this.snapshotFilterState();
    },
    resetCurrentFilter() {
      if (this.currentValue.value) this.currentFilter.value = JSON.parse(JSON.stringify(this.currentValue.value));
      else this.currentFilter.value = [];
      if (this.searchFilter && !this.optionsLoaded) this.initOptions();
    },
    initLabels() {
      let labels = [];
      for (let v of this.currentFilter.value) {
        let r = this.options.filter((o) => o[this.optionValueProperty] === v)[0];
        if (r) labels.push(r[this.optionLabelProperty]);
      }
      this.currentFilter.labels = labels;
    },
    initOptions() {
      const firstKey = Object.keys(this.searchFilter)[0];
      if (firstKey) this.searchFilter[firstKey] = null;
      this.options = [];
      this.currentFilter.value.forEach((value, index) => {
        this.options.push({id: value, display: this.currentValue.labels[index]});
      });
    },
    applyFilterCopy() {
      this.currentValue = {...this.currentFilter};
    },
    apply() {
      this.applyFilterCopy();
      this.$emit('apply');
    },
    clearFilter() {
      this.currentValue = {value: null, labels: []};
      this.currentFilter = {value: [], labels: []};
      if (this.$refs.autocomplete) {
        this.$refs.autocomplete.resetSuggestions();
      }
      if (this.searchFilter) this.initOptions();
    },
    reset() {
      this.clearFilter();
      if (!this.canGoBack) {
        this.$emit('apply');
      } else this.back();
    },
    back() {
      this.currentFilter.value = JSON.parse(JSON.stringify(this.currentValue.value ?? []));
      this.$emit('back');
    },
    onClick() {
      this.$emit('expand', this.name);
    },
    checkOption(option) {
      this.options.push(option);
      this.currentFilter.value.push(option.id);
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    nbSelected() {
      if (this.isExpanded) {
        if (!this.currentFilter.value) return null;
        return this.currentFilter.value.length;
      }
      if (!this.currentValue?.value) return null;
      return this.currentValue.value.length;
    },
    subtitle() {
      if (!this.currentValue?.labels?.length) return 'Tout';
      return this.currentValue.labels.join(', ');
    },
    isVisible() {
      return this.visible && (!this.optionsLoaded || this.options.length !== 0);
    },
    filteredOptions() {
      if (!this.optionFilter || !this.optionFilter.trim().length) return this.options;
      return this.options.filter((o) =>
        o[this.optionLabelProperty].toLowerCase().includes(this.optionFilter.toLowerCase().trim()),
      );
    },
  },
  watch: {
    'currentValue.value'(newVal) {
      if (!newVal) this.currentFilter.value = [];
      else this.currentFilter.value = JSON.parse(JSON.stringify(newVal));

      if (this.options?.length && newVal?.length)
        this.currentValue.labels = this.options
          .filter((o) => newVal.includes(o[this.optionValueProperty]))
          .map((o) => o[this.optionLabelProperty]);
    },
    'currentFilter.value'(newVal) {
      if (!this.canGoBack) {
        this.initLabels();
      }
      if (newVal?.length === 0 && this.searchFilter && !this.optionsLoaded) {
        this.initOptions();
      }
    },

    isExpanded(newVal) {
      this.resetCurrentFilter();
      this.optionFilter = null;
    },
  },
};
